import { render, staticRenderFns } from "./suitch-soilv1.vue?vue&type=template&id=1470e62f&scoped=true&"
import script from "./suitch-soilv1.vue?vue&type=script&lang=js&"
export * from "./suitch-soilv1.vue?vue&type=script&lang=js&"
import style0 from "./suitch-soilv1.vue?vue&type=style&index=0&id=1470e62f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470e62f",
  null
  
)

export default component.exports